import users from "./entities/users";
import groups from "./entities/groups";
import projects from "./entities/projects";
import roles from "./entities/roles";
import rfis from "./entities/rfis";
import rfis2 from "./entities/rfis2";
import attachments from "./entities/attachments";
import sheets from "./entities/sheets";
import photos from "./entities/photos";
import projectedSheetHistorySets from "./entities/projectedHistorySets";
import projectedAttachments from "./entities/projectedAttachments";
import userEvents from "./entities/userEvents";
import issues from "./entities/issues";
import uploads from "./entities/uploads";
import myEntitlements from "./entities/myEntitlements";
import projectEntitlements from "./entities/projectEntitlements";
import userEntitlements from "./entities/userEntitlements";
import orgEntitlements from "./entities/orgEntitlements";
import versionSets from "./entities/versionSets";
import CapiClient from "../generated/capi/client";
import raw from "../rawClients/rawCapiClient";
const NAME = "capiClient";
/*
 * When adding CAPI methods:
 *   - Nest under the first part of the CAPI path
 *   - Use a semantic verb as the first word in the method. This doesn't need to match the HTTP verb
 *     exactly, but GET should map to `get` or `getAll`.
 *   - Method arguments should be listed in this order:
 *      - url parameters (eg, `workspaceUid` in `/workspaces/${workspaceUid}`
 *      - query parameters object (eg, `{ updatedAt: updated_at }` in `/projects?updated_at=`
 *      - body object or body arguments
 */
const entities = {
  /** @hidden */
  NAME,
  projects,
  users,
  groups,
  roles,
  rfis,
  rfis2,
  attachments,
  sheets,
  photos,
  projectedSheetHistorySets,
  projectedAttachments,
  userEvents,
  issues,
  uploads,
  myEntitlements,
  projectEntitlements,
  userEntitlements,
  orgEntitlements,
  versionSets,
};
const client = new CapiClient(raw);
/**
 * Make requests to Customer API  (CAPI)
 */
const capiClient = {};
Object.getOwnPropertyNames(CapiClient.prototype).forEach(name => {
  if (name === "constructor") {
    return;
  }
  capiClient[name] = client[name].bind(client);
});
Object.assign(capiClient, entities);
// ensure `NAME` is readonly.
Object.defineProperty(capiClient, "NAME", {
  get: () => NAME,
});
export default capiClient;
